export const paths = [
  '/projects/:projectId/snapshots',
  '/projects/:projectId/snapshots/:action/:snapshotId',
];
